import {
  LENTES_PEL_CAMBIAR_PANEL_ACTIVO,
  LENTES_PEL_RESTABLECER_FILTRO,
  LENTES_PEL_MIS_CATALOGOS_MODIFICAR,
  LENTES_PEL_MIS_CATALOGOS_REQUEST,
  LENTES_PEL_SELECCIONAR_CARACTERISTICA_FILTRO,
  LENTES_PEL_FORMULARIO_FILTRO_ESTABLECER_OPCIONES_PANEL,
  LENTES_PEL_FORMULARIO_INICIALIZAR,
  LENTES_PEL_SELECCION_GRADUACION,
  LENTES_PEL_SELECCION_INDICE,
  LENTES_PEL_GET_COLORES_REQUEST,
  LENTES_PEL_GET_COLORES_SUCCESS,
  LENTES_PEL_GET_COLORES_FAILURE,
  LENTES_PEL_GET_FABRICANTES_REQUEST,
  LENTES_PEL_GET_FABRICANTES_SUCCESS,
  LENTES_PEL_GET_FABRICANTES_FAILURE,
  LENTES_PEL_SELECCION_COLOR,
  LENTES_PEL_SELECCION_COLOR_INTENSIDAD,
  LENTES_PEL_SELECCION_FABRICANTE,
  LENTES_PEL_GET_LENTES_LIST_SUCCESS,
  LENTES_PEL_GET_LENTES_LIST_FAILURE,
  LENTES_PEL_GET_PASILLOS_REQUEST,
  LENTES_PEL_GET_PASILLOS_SUCCESS,
  LENTES_PEL_GET_PASILLOS_FAILURE,
  LENTES_PEL_SELECCION_PASILLO,
  LENTES_PEL_GET_INDICES_REQUEST,
  LENTES_PEL_GET_INDICES_SUCCESS,
  LENTES_PEL_GET_INDICES_FAILURE,
  LENTES_PEL_SELECCION_LENTE,
  LENTES_PEL_SELECCION_TRATAMIENTO_LENTE,
  LENTES_PEL_SET_INICIALIZADO,
  LENTES_PEL_GET_LENTES_LIST_REQUEST,
  LENTES_PEL_SET_SEARCH_VALUE,
  LENTES_PEL_SELECCION_LENTE_TIPO_PVP,
  LENTES_PEL_CLEAR_TOOLBAR_DATA,
  LENTES_PEL_SET_MODO,
  LENTES_PEL_SELECCION_GRADUACION_GENERICA,
  LENTES_PEL_GET_LENTESTIPOSPVP_SUCCESS,
  LENTES_PEL_GET_LENTESTIPOSPVP_FAILURE,
  LENTES_PEL_GET_LENTESTIPOSPVP_REQUEST,
  LENTES_PEL_SET_DIAMETRO_MINIMO,
  LENTES_PEL_GET_ORDEN_GRADUACION_REQUEST,
  LENTES_PEL_GET_ORDEN_GRADUACION_SUCCESS,
  LENTES_PEL_GET_ORDEN_GRADUACION_FAILURE,
  LENTES_PEL_GET_COLORES_LENTE_REQUEST,
  LENTES_PEL_GET_COLORES_LENTE_SUCCESS,
  LENTES_PEL_GET_COLORES_LENTE_FAILURE,
  LENTES_PEL_GET_DIAMETROS_POSIBLES_SUCCESS,
  LENTES_PEL_GET_DIAMETROS_POSIBLES_FAILURE,
  LENTES_PEL_GET_DIAMETROS_POSIBLES_REQUEST,
  LENTES_PEL_SELECCION_DIAMETRO,
  LENTES_PEL_SET_VIENE_DE,
  LENTES_PEL_OBTENER_DATOS_LENTES,
  LENTES_PEL_PROCESS_FINAL_SELECTION,
  LENTES_PEL_SET_FINAL_SELECTION,
  LENTES_PEL_SET_ALTURA_FOCAL,
  SET_ERROR_SELECCION_LENTE,
  LENTES_PEL_ESTABLECER_DNP_OBLIGATORIO,
  LENTES_PEL_GET_TRATAMIENTOS_POSIBLES_REQUEST,
  LENTES_PEL_GET_TRATAMIENTOS_POSIBLES_SUCCESS,
  LENTES_PEL_GET_TRATAMIENTOS_POSIBLES_FAILURE,
  LENTES_PEL_SET_FUERA_NORMA, CLEAR_LENTES_LIST_ACTION, NEXT_PAGE_LENTES_LIST,
} from '../constants/pel.constants';

export const setModo = modo => ({
  type: LENTES_PEL_SET_MODO,
  payload: modo,
});
export const setVieneDe = viene_de => ({
  type: LENTES_PEL_SET_VIENE_DE,
  payload: { viene_de },
});
export const seleccionarCaracteristicaFiltrado = (caracteristica, valorSeleccionado, permisos) => ({
  type: LENTES_PEL_SELECCIONAR_CARACTERISTICA_FILTRO,
  payload: { caracteristica, valorSeleccionado, permisos },
});

export const obtenerFiltrosFromDB = () => ({
  type: LENTES_PEL_MIS_CATALOGOS_REQUEST,
});

export const cargarMisCatalogos = datos => ({
  type: LENTES_PEL_MIS_CATALOGOS_MODIFICAR,
  payload: datos,
});

export const cambiarPanelActivo = ({ panelActivo }) => ({
  type: LENTES_PEL_CAMBIAR_PANEL_ACTIVO,
  payload: { panelActivo },
});

export const restablecerFiltro = () => ({
  type: LENTES_PEL_RESTABLECER_FILTRO,
});
export const establecerDnpObligatorio = dnpObligatorio => ({
  type: LENTES_PEL_ESTABLECER_DNP_OBLIGATORIO,
  payload: dnpObligatorio,
});

export const establecerOpcionesFormularioPanel = ({ panel, opciones }) => ({
  type: LENTES_PEL_FORMULARIO_FILTRO_ESTABLECER_OPCIONES_PANEL,
  payload: {
    panel,
    opciones,
  },
});

export const inicializarFormulario = () => ({
  type: LENTES_PEL_FORMULARIO_INICIALIZAR,
});
export const setGraduacionGenerica = (valor, tipo) => ({
  type: LENTES_PEL_SELECCION_GRADUACION_GENERICA,
  payload: { valor, tipo },
});
export const setSeleccionLenteTipoPvp = lenteTipoPvpId => ({
  type: LENTES_PEL_SELECCION_LENTE_TIPO_PVP,
  payload: { lenteTipoPvpId },
});
export const getLentesTiposPvpsRequest = lentesTiposPvps => ({
  type: LENTES_PEL_GET_LENTESTIPOSPVP_REQUEST,
  payload: lentesTiposPvps,
});
export const getLentesTiposPvpsSuccesAction = lentesTiposPvps => ({
  type: LENTES_PEL_GET_LENTESTIPOSPVP_SUCCESS,
  payload: lentesTiposPvps,
});
export const getLentesTiposPvpsFailureAction = error => ({
  type: LENTES_PEL_GET_LENTESTIPOSPVP_FAILURE,
  payload: error,
});
export const setSeleccionGraduacion = ojos => ({
  type: LENTES_PEL_SELECCION_GRADUACION,
  payload: ojos,
});
export const setSeleccionIndice = (indiceId, isSelected) => ({
  type: LENTES_PEL_SELECCION_INDICE,
  payload: { indiceId, isSelected },
});
export const setSeleccionColor = colorId => ({
  type: LENTES_PEL_SELECCION_COLOR,
  payload: { colorId },
});
export const setDiametroMinimo = diametroMinimo => ({
  type: LENTES_PEL_SET_DIAMETRO_MINIMO,
  payload: diametroMinimo,
});
export const setSeleccionFabricante = fabricanteId => ({
  type: LENTES_PEL_SELECCION_FABRICANTE,
  payload: { fabricanteId },
});
export const setSeleccionPasillo = pasilloId => ({
  type: LENTES_PEL_SELECCION_PASILLO,
  payload: pasilloId,
});
export const setSelecccionLente = lenteKey => ({
  type: LENTES_PEL_SELECCION_LENTE,
  payload: lenteKey,
});
export const setSelecccionTratamientoLente = (lenteKey, tratamientoId) => ({
  type: LENTES_PEL_SELECCION_TRATAMIENTO_LENTE,
  payload: { lenteKey, tratamientoId },
});
export const getMisColoresRequest = gamaColor => ({
  type: LENTES_PEL_GET_COLORES_REQUEST,
  payload: gamaColor,
});
export const obtenerColoresSuccessAction = (datos, modo, trabajaConColores) => ({
  type: LENTES_PEL_GET_COLORES_SUCCESS,
  payload: { misColores: datos, modo, trabajaConColores },
});
export const obtenerColoresFailureAction = error => ({
  type: LENTES_PEL_GET_COLORES_FAILURE,
  payload: error,
});
export const getMisFabricantesRequest = () => ({
  type: LENTES_PEL_GET_FABRICANTES_REQUEST,
});
export const getMisFabricantesSuccessAction = datos => ({
  type: LENTES_PEL_GET_FABRICANTES_SUCCESS,
  payload: datos,
});
export const getMisFabricantesFailureAction = error => ({
  type: LENTES_PEL_GET_FABRICANTES_FAILURE,
  payload: error,
});
export const getLentesListRequest = datos => ({
  type: LENTES_PEL_GET_LENTES_LIST_REQUEST,
  payload: datos,
});
export const getLentesListSuccessAction = datos => ({
  type: LENTES_PEL_GET_LENTES_LIST_SUCCESS,
  payload: datos,
});
export const getLentesListFailureAction = error => ({
  type: LENTES_PEL_GET_LENTES_LIST_FAILURE,
  payload: error,
});
export const clearLentesListAction = () => ({
  type: CLEAR_LENTES_LIST_ACTION,
});
export const nextPageAction = () => ({
  type: NEXT_PAGE_LENTES_LIST,
});
export const getMisPasillosRequest = () => ({
  type: LENTES_PEL_GET_PASILLOS_REQUEST,
});
export const getMisPasillosSuccessAction = datos => ({
  type: LENTES_PEL_GET_PASILLOS_SUCCESS,
  payload: datos,
});
export const getMisPasillosFailureAction = error => ({
  type: LENTES_PEL_GET_PASILLOS_FAILURE,
  payload: error,
});
export const getMisIndicesRequest = () => ({
  type: LENTES_PEL_GET_INDICES_REQUEST,
});
export const getMisIndicesSuccessAction = datos => ({
  type: LENTES_PEL_GET_INDICES_SUCCESS,
  payload: datos,
});
export const getMisIndicesFailureAction = error => ({
  type: LENTES_PEL_GET_INDICES_FAILURE,
  payload: error,
});
export const processFinalSelection = (usaVentanaTrazadora, pedirSuplementos, callback) => ({
  type: LENTES_PEL_PROCESS_FINAL_SELECTION,
  payload: { usaVentanaTrazadora, pedirSuplementos, callback },
});
export const setFinalSelection = datos => ({
  type: LENTES_PEL_SET_FINAL_SELECTION,
  payload: datos,
});
export const setInicializado = inicializado => ({
  type: LENTES_PEL_SET_INICIALIZADO,
  payload: inicializado,
});
export const seleccionarColorIntensidad = (lenteKey, colorIntensidadId) => ({
  type: LENTES_PEL_SELECCION_COLOR_INTENSIDAD,
  payload: { lenteKey, colorIntensidadId },
});
export const setSelecccionDiametroLente = (lenteKey, diametroOption) => ({
  type: LENTES_PEL_SELECCION_DIAMETRO,
  payload: { ...diametroOption, lenteKey },
});
export const setAlturaFocal = (lenteKey, alturaOption) => ({
  type: LENTES_PEL_SET_ALTURA_FOCAL,
  payload: { ...alturaOption, lenteKey },
});
export const setSearchLentesValue = value => ({
  type: LENTES_PEL_SET_SEARCH_VALUE,
  payload: value,
});
export const clearToolbarDatos = () => ({
  type: LENTES_PEL_CLEAR_TOOLBAR_DATA,
});
export const setFueraDeNorma = value => ({
  type: LENTES_PEL_SET_FUERA_NORMA,
  payload: value,
});

export const getOrdenGraduacionRequest = () => ({
  type: LENTES_PEL_GET_ORDEN_GRADUACION_REQUEST,
});
export const getOrdenGraduacionSuccessAction = orden => ({
  type: LENTES_PEL_GET_ORDEN_GRADUACION_SUCCESS,
  payload: orden,
});
export const getOrdenGraduacionFailureAction = error => ({
  type: LENTES_PEL_GET_ORDEN_GRADUACION_FAILURE,
  payload: error,
});
export const getColoresLenteRequest = lente => ({
  type: LENTES_PEL_GET_COLORES_LENTE_REQUEST,
  payload: lente,
});
export const getColoresLenteFailureAction = error => ({
  type: LENTES_PEL_GET_COLORES_LENTE_FAILURE,
  payload: error,
});
export const getColoresLenteSuccessAction = (lente, coloresLente) => ({
  type: LENTES_PEL_GET_COLORES_LENTE_SUCCESS,
  payload: { colores: coloresLente, lente },
});
export const getDiametrosPosiblesRequest = lente => ({
  type: LENTES_PEL_GET_DIAMETROS_POSIBLES_REQUEST,
  payload: lente,
});
export const getTratamientosPosiblesRequest = lente => ({
  type: LENTES_PEL_GET_TRATAMIENTOS_POSIBLES_REQUEST,
  payload: lente,
});
export const obtenerDatosLentesRequest = lente => ({
  type: LENTES_PEL_OBTENER_DATOS_LENTES,
  payload: lente,
});
export const getDiametrosPosiblesSuccessAction = (lente, diametros) => ({
  type: LENTES_PEL_GET_DIAMETROS_POSIBLES_SUCCESS,
  payload: { lente, diametros },
});
export const getDiametrosPosiblesFailureAction = error => ({
  type: LENTES_PEL_GET_DIAMETROS_POSIBLES_FAILURE,
  payload: error,
});
export const getTratamientosPosiblesSuccessAction = (lente, tratamientos) => ({
  type: LENTES_PEL_GET_TRATAMIENTOS_POSIBLES_SUCCESS,
  payload: { lente, tratamientos },
});
export const getTratamientosPosiblesFailureAction = error => ({
  type: LENTES_PEL_GET_TRATAMIENTOS_POSIBLES_FAILURE,
  payload: error,
});
export const setErrorSeleccionLente = error => ({
  type: SET_ERROR_SELECCION_LENTE,
  payload: error,
});
